// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  //production
  appUrl: 'https://ticketsupport.expertapps.com.sa', // Histo Training URL
  apiUrl: 'https://ticketsupportapi.expertapps.com.sa/api', // Histo Training API front
  signalR: 'https://ticketsupportslr.expertapps.com.sa/hubs', // Histo Training SignalR

  appZoomUrl: 'https://histo.expertapps.com.sa/',
  apiZoomUrl: 'https://histoapi.expertapps.com.sa/api',

  googleApiKey: 'AIzaSyBdScej8zNyAjz4YQuoWeo0jTfYv56pFc4',
  googleSiteKey: '6LeIGsocAAAAAAgHB8An7QMb99naC8cdTXL0qi-t',
  deepgramKey: 'd87da8e8561cbbeba35e4d69d495c0dbeb52af94'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
